import * as yup from 'yup'

export interface StatementOfConformitySignatureDto {
  statementOfConformitySignatureFileName?: string
  statementOfConformitySignatureFile?: File
}

export const statementOfConformitySignatureInit: StatementOfConformitySignatureDto = {
  statementOfConformitySignatureFileName: undefined,
  statementOfConformitySignatureFile: undefined
}

export const statementOfConformitySignatureValidationSchema = yup.object<StatementOfConformitySignatureDto>({
  statementOfConformitySignatureFile: yup.mixed().required('Signature is required.')
})
